// extracted by mini-css-extract-plugin
export default {"switcher":"B09jT0"};